<template><ContactSubPage :title="{ 'zh-CN': '营销中心', 'en-US': 'Marketing Center' }" /></template>
<script>
import ContactSubPage from "./ContactSubPage.vue";
export default { name: "MarketingCenterPage", components: { ContactSubPage } };
</script>
